/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdatePictureResponse } from '../../models/update-picture-response';

export interface UpdateProfilePicture$Params {
      body?: {
'picture': Blob;
}
}

export function updateProfilePicture(http: HttpClient, rootUrl: string, params?: UpdateProfilePicture$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdatePictureResponse>> {
  const rb = new RequestBuilder(rootUrl, updateProfilePicture.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdatePictureResponse>;
    })
  );
}

updateProfilePicture.PATH = '/api/company/profile-picture';
